module.exports = __webpack_public_path__ + "static/shenhe-180440a7d36bb1d67108649c1933abda.png";